import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { parseCustomFieldSearchParams } from '@/common/zod-schemas/common/filters';
import { itemFilterUrlSearchSchema } from '@/common/zod-schemas/itemFilterUrlSearchSchema';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { ensureScenarioOrRedirect } from '@/features/planner/utils/ensureScenarioOrRedirect';
import { setLastVisitedScenarioId } from '@/features/planner/utils/lastVisitedScenario';

const paramsSchema = z.object({
  scenarioId: z.coerce.number().int().positive(),
});

// Declared here (the scenario parent route), not on the table/ or timeline/ leaves, so both
// inherit the same item-filter search state instead of maintaining two separate schemas.
const scenarioSearchSchema = itemFilterUrlSearchSchema.extend({
  ...itemPanelSearchSchema.shape,
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId')({
  params: paramsSchema,
  validateSearch: (search: Record<string, unknown>) => ({
    ...scenarioSearchSchema.parse(search),
    ...parseCustomFieldSearchParams(search),
  }),
  beforeLoad: async ({ params: { loopId, scenarioId, org }, context: { queryClient } }) => {
    setLastVisitedScenarioId(loopId, scenarioId);
    await ensureScenarioOrRedirect({ loopId, scenarioId, org, queryClient });
  },
});
